import * as React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Typography } from 'omakase';

const useStyles = makeStyles((theme: Theme) => ({
  focusedPanelSeparator: {
    display: 'flex',
    justifyContent: 'center',
    margin: `${theme.spacing(3)}px 0`,
    position: 'relative',
    zIndex: 0,
  },
  noText: {
    height: theme.typography.pxToRem(1),
  },
  focusedPanelSeparatorLine: {
    backgroundColor: theme.colors.borderDefault,
    bottom: 'initial',
    height: 1,
    left: 0,
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    zIndex: 1,
  },
  focusedPanelSeparatorText: {
    backgroundColor: theme.colors.bgDefault,
    color: theme.colors.fgDefault,
    padding: `0 ${theme.spacing(1)}px`,
    zIndex: 2,
  },
}));

interface Props {
  text?: string;
  modifierClassName?: string;
}

const FocusedPanelSeparator: React.FunctionComponent<Props> = ({ text, modifierClassName }) => {
  const classes = useStyles();
  const className = clsx(classes.focusedPanelSeparator, modifierClassName, {
    [classes.noText]: !text,
  });
  return (
    <div className={className}>
      <div className={classes.focusedPanelSeparatorLine} />
      <div className={classes.focusedPanelSeparatorText}>
        <Typography component="div" variant="body02Strong" color="fgDefault">
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default FocusedPanelSeparator;
